import React, { FC, useState, useEffect } from 'react';
import {
  Box,
  Card,
  TableCell,
  TableRow,
  TableContainer,
  Typography,
  Button, IconButton
} from '@mui/material';
import { ActionCell, DynamicTable, TableSearch } from '../../../components/DynamicTable/DynamicTable';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

export interface ScrappedItem {

  name: string;
  price: string;
  description: string;
  attributes: any[];
  images: string;

}

type ScraperProps = {
  scrappedData: ScrappedItem[];
}

const ScraperContent = (props: ScraperProps) => {
  const { scrappedData: initialScrappedData } = props;

  const [scrappedData, setScrappedData] = useState<ScrappedItem[]>(initialScrappedData);
  const [reload, setReload] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<ScrappedItem[] | null>([]);
  const [page, setPage] = useState<number>(0);







  return (
    <Box>
      <Box sx={{
        padding: '2%'
      }}>
        <Typography variant="h4" component="h3" gutterBottom>
          List of website scrapped
        </Typography>
        <Typography variant="subtitle2">
          Below will contain the list of accounts scrapped
        </Typography>

      </Box>
      <Box sx={{
        width: '100%',
        borderBottom: '1px solid #d8d8d8',
        height:'1px'
      }}/>
      <Box sx={{
        padding: '1%'
      }}>
        <TableContainer>
          <DynamicTable
            showPagination={false}
            rowsPerPage={10} //use this one for the meantime.
            page={page}

            searchElement={
              <TableSearch
                placeholder={'Search Products'}
                searchData={initialScrappedData}
                setSearchData={setSearchData}
              />
            }
            // add select fields to filter data by brand, vendor, product etc
            headers={[
              {
                headerName: 'Products Name',
                field: 'name',
              },
              {
                headerName: 'Price',
                field: 'price'
              },
              {
                headerName: 'Attributes',
                field: 'attributes',
                renderCell: (value) => {
                  return (
                    <Button variant={'contained'}>View Attributes</Button>
                  );
                }
              },
              {
                headerName: 'Images',
                field: 'images',
                renderCell: (value) => {
                  return (
                    <img src={value.row.images} alt={value.row.name} style={{ width: '100px', height: '100px' }} />
                  );
                }
              }
            ]}

            rows={initialScrappedData?.map((row) => ({
              id: row.name,
              name: row.name,
              price: row.price,
              attributes: row.attributes,
              images: row.images,
              actions: row
              }))}

           />
        </TableContainer>
      </Box>
    </Box>

  );
};

export default ScraperContent;
